import axios from 'axios'

const DEFAULT_BASE_URL = 'https://ahs-adapter-server-test.turingsenseai.com'

const AHS_ADAPTER_BASE_URL = process.env.VUE_APP_AHS_ADAPTER_BASE_URL || DEFAULT_BASE_URL

const post = async (path, data) => {
  const res = await axios({
    method: 'post',
    url: `${AHS_ADAPTER_BASE_URL}${path}`,
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
  return res.data
}

export const queryAHSContext = data => post('/ahs/appraisal/context', data)

export const uploadAHSImage = data => post('/ahs/appraisal/upload', data)

export const submitAHSSingle = data => post('/ahs/appraisal/single', data)

export const submitAHSOverall = data => post('/ahs/appraisal/overall', data)

export const reportAHSCameraEvent = data => post('/ahs/appraisal/camera/report', data)
